import React from "react";

const AboutImpact = () => {
  return (
    <section className="w-full bg-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20">
        <div className="rounded-2xl border border-[color:var(--border)] bg-[color:var(--surface)] p-10">
          <div className="grid gap-8 lg:grid-cols-3">
            <div>
              <div className="text-4xl font-semibold text-[color:var(--navy)]">
                0
              </div>
              <div className="mt-2 text-sm font-semibold text-[color:var(--brand)]">
                PPM for 4 months
              </div>
              <div className="mt-2 text-sm text-[color:var(--muted)]">
                Sustained reduction through disciplined problem-solving.
              </div>
            </div>

            <div>
              <div className="text-4xl font-semibold text-[color:var(--navy)]">
                30%
              </div>
              <div className="mt-2 text-sm font-semibold text-[color:var(--brand)]">
                Internal scrap reduction
              </div>
              <div className="mt-2 text-sm text-[color:var(--muted)]">
                Improvement delivered through process consistency and adoption.
              </div>
            </div>

            <div>
              <div className="text-4xl font-semibold text-[color:var(--navy)]">
                Global
              </div>
              <div className="mt-2 text-sm font-semibold text-[color:var(--brand)]">
                Cross-industry support
              </div>
              <div className="mt-2 text-sm text-[color:var(--muted)]">
                Transferable frameworks that scale across teams and sites.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutImpact;
